import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";

import EditButton from "components/CustomButtons/EditButton";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getSite,
  postActionImpact,
} from "services/ConfigServices";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const [totalRows, setTotalRows] = useState(0);
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([
    { energy: " ", savingsvalue: " " },
  ]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {}, [isRefetched]);

  useEffect(() => {

    console.log("useEffect action.parameters?.impact?.savings");
    getSavings();
  }, [isRefetched, action.parameters?.impact?.savings]);

  const getSavings = async (route) => {
    setStructureData(action.parameters?.impact?.savings || []);
  };

  const handleSimulate = (event) => {
    axios
      .post(postActionImpact(action.id), action, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((response) => {
        let { data } = response;
        setAction((prevState) => ({
          ...prevState,
          parameters: {
            ...prevState.parameters,
            impact: {
              ...prevState.parameters.impact,
              investment : data.invest,
              savings: data.savings,
            },

            projections: {
              ...prevState.parameters.projections,
              projectedfinalenergysavings: data.projectedfinalenergysavings,
              projectedprimaryenergysavings: data.projectedprimaryenergysavings,
              projectedwatersavings: data.projectedwatersavings,
              projectedsavings: data.projectedsavings,
              investment: data.investment,
              projectedroi: data.projectedroi,
              projectedco2savings: data.projectedco2savings,
              projectedwatersavings: data.projectedwatersavings,
            },
          },
        }));
      });
  };

  // ----------------------------------------------------------

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <TableName>Simulation</TableName>
        {actionplanupdate && (
          <EditButton handleSubmit={handleSimulate}>Simuler</EditButton>
        )}
      </>
    );
  }, [action.parameters.impact]);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    refreshTable,
  };
}
